export default {
    imageEditorFirms: { list: [], modal: { imageEditorFirm: {} } }
};
